"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryNavTrayFeature = PrimaryNavTrayFeature;
exports.PrimaryNavTrayFeatureContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = require("@site/pattern-library-core/image");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
const ImageWrap = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageWrap",
  class: "pl-iz3wd0e"
});
const PrimaryNavTrayFeatureContainer = exports.PrimaryNavTrayFeatureContainer = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "PrimaryNavTrayFeatureContainer",
  class: "pl-pjzol28"
});

/**
 * Primary Nav Tray Feature component.
 *
 * @param {Object} props React props
 * @param {String} props.id Element id
 * @param {Object} props.image Image string
 * @param {string} props.href Href for image/text
 * @param {string} props.text Text below image
 * @param {string} props._name Name for tracking
 * @returns {React.ReactElement} Primary Nav Tray Feature
 * @public
 */
function PrimaryNavTrayFeature({
  id,
  image,
  href,
  text,
  _name
}) {
  const {
    url,
    height,
    width,
    altText
  } = image;
  return /*#__PURE__*/_react.default.createElement(PrimaryNavTrayFeatureContainer, (0, _extends2.default)({
    id: id,
    href: href
  }, _patternLibraryUtils.tracking.create(_name, true, false), {
    "data-cy": "primary-nav-tray-feature"
  }), /*#__PURE__*/_react.default.createElement(ImageWrap, null, /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    dataSrc: url,
    height: height,
    width: width,
    altText: altText
  })), /*#__PURE__*/_react.default.createElement("strong", null, text));
}
PrimaryNavTrayFeature.propTypes = {
  id: _propTypes.default.string,
  image: _propTypes.default.shape({
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    altText: _propTypes.default.string,
    url: _propTypes.default.string
  }).isRequired,
  href: _propTypes.default.string.isRequired,
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  _name: _propTypes.default.string
};